import { TEMPLATES_FILTERED } from 'constants/mixpanel';
import {
  Layout,
  PageSize,
  TemplateFilters,
  TemplateType,
} from 'hooks/usePaginatedTemplatesSearch/usePaginatedTemplatesSearch.types';

import { toggleLayoutFilter, togglePageSizeFilter, togglePlanTypeFilter } from './TemplatesFilter.helpers';
import { TemplateFilterConfig, TemplateFilterSectionConfig } from './TemplatesSearch.types';

/**
 * Config for template filters to be displayed in the side menu template search
 */
const TEMPLATE_FILTER_CONFIG: TemplateFilterSectionConfig[] = [
  {
    sectionTitleKey: 'filters.sectionTitles.planType',
    filters: [
      {
        labelKey: 'filters.planType.free',
        mpFilterName: TEMPLATES_FILTERED.filterName.Free,
        checkIsApplied: (filters: TemplateFilters) => !!filters?.planType?.includes(TemplateType.Free),
        toggleFilter: (filters: TemplateFilters) => {
          return togglePlanTypeFilter(filters, TemplateType.Free);
        },
      },
      {
        labelKey: 'filters.planType.premium',
        mpFilterName: TEMPLATES_FILTERED.filterName.Premium,
        checkIsApplied: (filters: TemplateFilters) => !!filters?.planType?.includes(TemplateType.Premium),
        toggleFilter: (filters: TemplateFilters) => {
          return togglePlanTypeFilter(filters, TemplateType.Premium);
        },
      },
      {
        labelKey: 'filters.planType.business',
        mpFilterName: TEMPLATES_FILTERED.filterName.Business,
        checkIsApplied: (filters: TemplateFilters) => !!filters?.planType?.includes(TemplateType.Business),
        toggleFilter: (filters: TemplateFilters) => {
          return togglePlanTypeFilter(filters, TemplateType.Business);
        },
      },
    ],
  },
  {
    sectionTitleKey: 'filters.sectionTitles.pageSize',
    filters: [
      {
        labelKey: 'filters.pageSize.letter',
        mpFilterName: TEMPLATES_FILTERED.filterName.Letter,
        checkIsApplied: (filters: TemplateFilters) => !!filters?.pageSize?.includes(PageSize.Letter),
        toggleFilter: (filters: TemplateFilters) => {
          return togglePageSizeFilter(filters, PageSize.Letter);
        },
      },
      {
        labelKey: 'filters.pageSize.custom',
        mpFilterName: TEMPLATES_FILTERED.filterName.Custom,
        checkIsApplied: (filters: TemplateFilters) => !!filters?.pageSize?.includes(PageSize.Custom),
        toggleFilter: (filters: TemplateFilters) => {
          return togglePageSizeFilter(filters, PageSize.Custom);
        },
      },
      {
        labelKey: 'filters.pageSize.square',
        mpFilterName: TEMPLATES_FILTERED.filterName.Square,
        checkIsApplied: (filters: TemplateFilters) => !!filters?.pageSize?.includes(PageSize.Square),
        toggleFilter: (filters: TemplateFilters) => {
          return togglePageSizeFilter(filters, PageSize.Square);
        },
      },
    ],
  },
  {
    sectionTitleKey: 'filters.sectionTitles.layout',
    filters: [
      {
        labelKey: 'filters.layout.portrait',
        mpFilterName: TEMPLATES_FILTERED.filterName.Portrait,
        checkIsApplied: (filters: TemplateFilters) => !!filters?.layout?.includes(Layout.Portrait),
        toggleFilter: (filters: TemplateFilters) => {
          return toggleLayoutFilter(filters, Layout.Portrait);
        },
      },
      {
        labelKey: 'filters.layout.landscape',
        mpFilterName: TEMPLATES_FILTERED.filterName.Landscape,
        checkIsApplied: (filters: TemplateFilters) => !!filters?.layout?.includes(Layout.Landscape),
        toggleFilter: (filters: TemplateFilters) => {
          return toggleLayoutFilter(filters, Layout.Landscape);
        },
      },
    ],
  },
  {
    sectionTitleKey: 'filters.sectionTitles.other',
    filters: [
      {
        labelKey: 'filters.other.accessible',
        mpFilterName: TEMPLATES_FILTERED.filterName.Accessible,
        checkIsApplied: (filters: TemplateFilters) => !!filters?.isAccessible,
        toggleFilter: (filters: TemplateFilters) => {
          filters.isAccessible = !filters.isAccessible;
          return filters;
        },
      },
    ],
  },
];

// Flattened array of all filters
const TEMPLATE_FILTERS: TemplateFilterConfig[] = TEMPLATE_FILTER_CONFIG.reduce((acc, sectionConfig) => {
  acc.push(...sectionConfig.filters);
  return acc;
}, [] as TemplateFilterConfig[]);

export { TEMPLATE_FILTER_CONFIG, TEMPLATE_FILTERS };
